import React, { useEffect, useState } from "react";
import {
  useNavigate,
  useParams
} from "react-router-dom";
import { BuscarCursoID } from "../../services/CursoService";
import "./styles/BienvenidaCurso.scss";

import imagenBienvenida1 from "../:./../../assets/img/bienvenida/bienvenida_1.png";
import imagenBienvenida2 from "../:./../../assets/img/bienvenida/bienvenida_2.png";
import imagenBienvenida3 from "../:./../../assets/img/bienvenida/bienvenida_3.png";

import ButtonZegel from "../../components/Buttons/ButtonZegel";
import FooterInterno from "../../components/Footer/FooterInterno";
import useAlumno from "../../hooks/useAlumno";
import { PrivateRoutes } from "../../routes/routes";
import { ActualizarOnboardingV2, ObtenerCursoUsuarioPorId } from "../../services/UsuarioService";
import CarruselBienvenidaPrograma from "./CarruselBienvenidaPrograma";

const BienvenidaCursoPrograma = () => {
  let { idCursoUsuario } = useParams();
  const navigate = useNavigate()
  const { perfil } = useAlumno();
  const [curso, setCurso] = useState(null);
  const [cursoUsuario, setCursoUsuario] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const GetCursoUsuario = () => {
      let jwt = window.localStorage.getItem("jwt");
      let id = idCursoUsuario
      ObtenerCursoUsuarioPorId({ jwt, id }).then((data) => {
        setCursoUsuario(data);
        /* if(data.bienvenida === false)
        {
          navigate("/"+PrivateRoutes.HOME+"/CursoInterno/"+data.idPersonaCurso)
        } */
      });
    };
    if (idCursoUsuario) GetCursoUsuario();
  }, [idCursoUsuario]);

  useEffect(() => {
    if (perfil) {
      if (perfil.onboardingPrograma) {
        navigate("/" + PrivateRoutes.HOME + "/" + PrivateRoutes.DASHBOARD)
      }
    }
  }, [perfil]);
  useEffect(() => {
    const GetCurso = () => {
      let jwt = window.localStorage.getItem("jwt");
      let idCurso = cursoUsuario.idCurso;
      BuscarCursoID({ jwt, idCurso }).then((data) => {
        setCurso(data);
      });
    };
    if (cursoUsuario) GetCurso();
  }, [cursoUsuario]);

  const ActualizarUsuarioPrograma = () => {
    let jwt = window.localStorage.getItem("jwt");
    let idUsuario = perfil.idUsuario

    let onboarding = false;
    let onboardingPrograma = true;
    let onboardingCurso = false;
    let usuario = JSON.stringify(
      { idUsuario, onboarding, onboardingPrograma, onboardingCurso},
      null,
      2
    );
    setLoading(true)
    ActualizarOnboardingV2({ usuario,jwt }).then(data => {
      setLoading(false)
      window.location.reload();
    })

  }

  return (
    <div className="dashboard-Bienvenida" >
      <div className="Bienvenida-content">
        <div className="b-content-mensaje-bienvenida">
          <div className="imagenCurso">
            {curso && <img src={curso.fotoCurso}></img>}
          </div>
          <div className="mensaje-bienvenida pl-4 ">
            {perfil && (
              <span className="text-xl font-bold w-full pb-2">{`¡Hola ${perfil.nombres}!`}</span>
            )}
            {curso && (
              // <span className="text-sm font-medium w-full">{`Te damos la bienvenida al curso ${curso.nombre}!`}</span>
              <span className="text-sm font-medium w-full">{`Tu ruta académica comienza aquí`}</span>
            )}
          </div>
        </div>
        <div className="text-xl font-bold mt-5 mb-4">
          Lo que encontrarás a continuación
        </div>

        <div className="b-content-detalle flex gap-3 mb-4 Bienvenidadesktop">
          <div className="b-detalle-block">
            <div className="detalle-block-img">
              <img src={imagenBienvenida1}></img>
            </div>
            <div className="detalle-block-detalle text-sm font-medium mt-2">
            Este programa está conformado por cursos. En ellos encontrarás diversas 
            unidades con lecciones dentro de cada una. Además, tendrás a tu disposición 
            los videos, materiales complementarios y ejercicios que nuestros docentes 
            han elaborado para ti.
            </div>
          </div>
          <div className="b-detalle-block">
            <div className="detalle-block-img">
              <img src={imagenBienvenida2}></img>
            </div>
            <div className="detalle-block-detalle text-sm font-medium mt-2">
            Al final de cada unidad de cada módulo te pediremos que respondas una evaluación, 
            tendrás 2 intentos y 45 minutos en cada uno para poder contestar.
            </div>
          </div>
          <div className="b-detalle-block">
            <div className="detalle-block-img">
              <img src={imagenBienvenida3}></img>
            </div>
            <div className="detalle-block-detalle text-sm font-medium mt-2">
            Para complementar tu aprendizaje tendrás habilitado un chat, donde podrás aclarar dudas 
            por curso. Además, tendrás acceso a nuestra Biblioteca Virtual.
            </div>
          </div>
        </div>
        <div className="b-content-footer flex align-items-center justify-content-end mb-3 w-full Bienvenidadesktop">
          <ButtonZegel
            label="Comenzar programa"
            color="primary-2"
            width="240px"
            loading={loading}
            onClick={() => ActualizarUsuarioPrograma()}
          ></ButtonZegel>
        </div>
        <div className=" p-fluid formgrid grid b-content-detalle flex mb-4 Bienvenidamobile" style={{ height: 470 }}>

          <CarruselBienvenidaPrograma />

          <div className=" col-12 md:col-4 mb-2 center-container">
            <div className="b-content-footer flex align-items-center justify-content-end mb-3 w-full Bienvenidamobile">
              <ButtonZegel
                label="Comenzar programa"
                color="primary-2"
                width="100%"
                loading={loading}
                onClick={() => ActualizarUsuarioPrograma()}
              ></ButtonZegel>
            </div>
          </div>
        </div>
      </div>

      <div style={{ width: "100%" }} className="Bienvenidadesktop"><FooterInterno /></div>

      <div style={{ width: "100%" }} className="Bienvenidamobile mobile mb-0 fixed-bottom"><FooterInterno /></div>
      
     

    </div>
  );
};

export default BienvenidaCursoPrograma;
